import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

import Text from 'components/Atoms/Text'
import Image from 'components/Atoms/Image'
import { withTranslation } from 'i18n-web/i18next'

const Component = styled(Row)`
  justify-content: center;
  text-align: center;
`

const EmailImage = styled(Image)`
  margin-bottom: 20px;
`

const Description = styled(Text)`
  margin-top: 10px;
`

const EmailVerification = ({ t }) => (
  <Component>
    <Col xs={12} sm={7}>
      <EmailImage width="170" src={'/static/images/verify_your_email.png'} />
      <Text className="center h3 normal" as="h1">
        {t('signUp.emailVerification.content.title')}
      </Text>
    </Col>
    <Col xs={12} sm={7}>
      <Description className="center medium spacing">
        {t('signUp.emailVerification.content.description')}
      </Description>
    </Col>
  </Component>
)

EmailVerification.propTypes = {
  t: PropTypes.func,
}

export default withTranslation()(EmailVerification)
